import useScrollProgress from "@/components/useScrollProgress";

// Two-column story: content on the left, a sticky panel on the right whose
// state is driven by scroll position. `rail(p)` receives progress 0..1.
// Below lg the panel is shown once, inline, in its finished state, unless
// inline={false} (used where the panel would only repeat the text beside it).
export default function ScrollRail({ children, rail, dark = false, inline = true, className = "" }) {
  const [ref, p] = useScrollProgress();
  return (
    <div ref={ref} className={`hp-rail-wrap ${className}`}>
      {inline && <div className="lg:hidden mb-10">{rail(1, true)}</div>}
      <div className="min-w-0">{children}</div>
      <aside className="hidden lg:block" aria-hidden="true">
        <div className={`hp-rail ${dark ? "hp-rail-dark" : ""}`}>{rail(p, false)}</div>
      </aside>
    </div>
  );
}

export const clamp01 = (x) => Math.min(1, Math.max(0, x));
// Maps global progress to a local 0..1 window.
export const win = (p, a, b) => clamp01((p - a) / (b - a));
